import Form from './LiaForm'
import schemaLiaForm from './schema'

const LiaForm = { Form, schemaLiaForm }

export default LiaForm
